import axios from "axios";
import { osmMapPolyline } from "../../../config";
import polyline from "@mapbox/polyline";

const fetchRouteData = async ({ routeUrl }) => {
  try {
    const response = await axios.get(routeUrl);
    const routeCoordinates = response.data.features[0].geometry.coordinates;
    const formattedCoordinates = routeCoordinates.map((coord) => [coord[1], coord[0]]);

    return { formattedCoordinates, response };
  } catch (error) {
    console.error("Error fetching route data with GET:", error);
    throw new Error("Error fetchRouteData", error);
  }
};

const fetchRouteDataPOST = async ({ startPos, endPos }) => {
  try {

    const requestData = {
      coordinates: [startPos, endPos]
    };

    const response = await axios.post(osmMapPolyline, requestData);

    const formattedCoordinates = polyline.decode(response.data.routes[0].geometry);
    
    return { formattedCoordinates, response };
  } catch (error) {
    console.error("Error fetching route data with POST:", error);
  }
};

export const updateRoute = async ({
  startPos,
  endPos,
  errorCallBack = () => null,
}) => {
  let routeUrl = `${osmMapPolyline}?start=${startPos}&end=${endPos}`;
  try {
    const [routeData, routeDatapost] = await Promise.all([
      fetchRouteData({ routeUrl }),
      fetchRouteDataPOST({ startPos, endPos })
    ]);
     if (routeDatapost && routeDatapost.formattedCoordinates) {
      routeData.formattedCoordinates = routeDatapost.formattedCoordinates;
    } 

    return routeData;
  } catch (error) {
    errorCallBack();
    throw new Error("Error fetchRouteData", error);
  }
};